import { Link } from "react-router-dom";
import { ROUTES } from "../lib/routes";
import { SocialLinks } from "./SocialLinks";
import { INSTITUTE_REACH } from "../lib/contact";
import { ThemeControls } from "./ThemeControls";

interface FooterColumn {
  title: string;
  items: Array<[label: string, to: string]>;
}

const COLUMNS: FooterColumn[] = [
  {
    title: "About us",
    items: [
      ["Leader's Message", `${ROUTES.about}#leader-message`],
      ["Campus Life", ROUTES.campusLife],
      ["Distinguished Visitors", ROUTES.visitors],
    ],
  },
  {
    title: "Academics",
    items: [
      ["Undergraduate", `${ROUTES.academics}#undergraduate`],
      ["Postgraduate", `${ROUTES.academics}#postgraduate`],
      ["Examinations", ROUTES.examinations],
      ["Library", ROUTES.library],
      ["Faculty", ROUTES.faculty],
    ],
  },
  {
    title: "Admissions",
    items: [
      ["Undergraduate", `${ROUTES.admissions}#be`],
      ["Postgraduate", `${ROUTES.admissions}#mtech`],
      ["Hostels & Mess", ROUTES.hostels],
      ["Fee Structure", ROUTES.admissions],
      ["Scholarships", ROUTES.scholarships],
    ],
  },
  {
    title: "Connect",
    items: [
      ["Notifications", ROUTES.notifications],
      ["Events", ROUTES.events],
      ["Placements", ROUTES.placements],
      ["Alumni", ROUTES.alumni],
      ["For Recruiters", ROUTES.recruiters],
      ["Contact", ROUTES.contact],
    ],
  },
  {
    title: "Compliance",
    items: [
      ["Mandatory Disclosures", ROUTES.disclosures],
      ["Green Campus", ROUTES.sustainability],
    ],
  },
];

export function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            {/* The institute's published reach — see lib/contact.ts. The
                prototype printed info@bietdvg.edu and an invented "233 800"
                exchange here; neither is published anywhere. */}
            <div className="footer-address">
              {INSTITUTE_REACH.address.map((line) => (
                <span key={line}>
                  {line}
                  <br />
                </span>
              ))}
              <br />
              <a href={`mailto:${INSTITUTE_REACH.emails.principal}`} style={{ display: "inline" }}>
                {INSTITUTE_REACH.emails.principal}
              </a>
              <br />
              {INSTITUTE_REACH.phone}
            </div>
            <SocialLinks variant="inline" heading="Follow" />
          </div>
          {COLUMNS.map((c) => (
            <div key={c.title}>
              <h4>{c.title}</h4>
              {c.items.map(([label, to]) =>
                to.startsWith("#") ? (
                  <a key={label} href={to}>
                    {label}
                  </a>
                ) : (
                  <Link key={label} to={to}>
                    {label}
                  </Link>
                ),
              )}
            </div>
          ))}
        </div>
        <div className="footer-appearance">
          <span className="footer-appearance-label">Colour</span>
          <ThemeControls />
        </div>
        <div className="footer-bottom">
          <div>
            © 2026 Bapuji Institute of Engineering &amp; Technology, Davanagere · A unit of
            Bapuji Educational Association
          </div>
          <div className="footer-bottom-links">
            <a href="#">Terms of use</a>
            <a href="#">Privacy Policy</a>
            <a href="#">Sitemap</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
